export const trackHasStems = (track: Track): boolean => {
	const hasAlgoliaStemsFlag = track.hasStems === true
	const hasStemsArray = (track.stems?.length ?? 0) > 0

	return hasAlgoliaStemsFlag || hasStemsArray
}
